import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { useViewportScroll } from 'framer-motion';

export const ShadowedStickyBox: React.FC<BoxProps> = (props) => {
  const ref = React.useRef<HTMLDivElement>();

  const [hasReachedTop, setReachedTop] = React.useState(false);

  const { scrollY } = useViewportScroll();

  React.useEffect(() => {
    return scrollY.onChange(() => {
      const { top = 0 } = ref.current?.getBoundingClientRect() ?? {};
      if (0 >= top) setReachedTop(true);
      else setReachedTop(false);
    });
  }, [scrollY]);

  return (
    <Box
      ref={ref}
      position="sticky"
      top="0"
      backgroundColor="scheme.bgPrimary"
      shadow={hasReachedTop ? 'md' : undefined}
      transition="box-shadow 0.2s"
      zIndex="docked"
      {...props}
    />
  );
};
